import Game from '../model/Game';

export function gameInitGet() {
    const game = new Game();

    return game;    
}

export function isStartF([user, game]) {
    let ch = false;
    console.log('isStartF', user, game);
    if (game.id === '' && user.id === '') {
        ch = true;        
    }
    return ch;
}

export function playerNameGet([user, game]) {
    let playerName = '';
    if (isStartF([user, game])) {
        playerName = game.player.list[user.id].name;
    }
    return playerName;
}

export function playerColorGet([user, game]) {
    let playerColor = '#ffffff';
    if (game.id !== '' && user.id !== '') {
        if (user.id in game.player.list) {
            playerColor = game.player.list[user.id].color;            
        }        
    }
    return playerColor;
}



